routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
     .state('home.events', {
       url: __env.routes.eventos,
       template: `<events sh-ctrl="shCtrl"></events>`
    })

}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/catalog/events/events.config.js